/**
 * Universal Search Functionality
 * Handles customer and boat search across the application
 */

export function initUniversalSearch() {
  let universalSearchTimeout = null;
  let universalSearchResults = [];

  window.initUniversalSearch = function() {
    // Universal search functionality
    let universalSearchTimeout = null;
    let universalSearchResults = [];

    window.initUniversalSearch = function() {
        const searchInput = document.getElementById('universalSearch');
        const resultsDiv = document.getElementById('universalSearchResults');

        if (!searchInput) return;

        // Search on input
        searchInput.addEventListener('input', function(e) {
            const query = e.target.value;

            // Clear previous timeout
            if (universalSearchTimeout) {
                clearTimeout(universalSearchTimeout);
            }

            // Hide results if query is empty
            if (!query || query.length < 2) {
                resultsDiv.style.display = 'none';
                universalSearchResults = [];
                return;
            }

            // Debounce search
            universalSearchTimeout = setTimeout(async () => {
                try {
                    // Use Supabase edge function
                    const supabaseUrl = window.app?.supabase?.supabaseUrl || import.meta.env?.VITE_SUPABASE_URL;
                    const supabaseKey = window.app?.supabase?.supabaseKey || import.meta.env?.VITE_SUPABASE_ANON_KEY;

                    const response = await fetch(`${supabaseUrl}/functions/v1/search-customers-with-boats?search=${encodeURIComponent(query)}`, {
                        headers: {
                            'apikey': supabaseKey,
                            'Authorization': `Bearer ${supabaseKey}`
                        }
                    });
                    const customers = await response.json();

                    if (customers && customers.length > 0) {
                        universalSearchResults = customers;
                        displayUniversalSearchResults(customers, resultsDiv);
                    } else {
                        universalSearchResults = [];
                        resultsDiv.innerHTML = '<div class="search-result-item no-results">No customers found</div>';
                        resultsDiv.style.display = 'block';
                    }
                } catch (error) {
                    console.error('Error searching customers:', error);
                    resultsDiv.style.display = 'none';
                }
            }, 300);
        });

        // Enter key to select first result
        searchInput.addEventListener('keydown', function(e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                if (universalSearchResults && universalSearchResults.length > 0) {
                    window.selectUniversalSearchCustomer(universalSearchResults[0]);
                }
            }
        });

        // Click outside to close
        document.addEventListener('click', function(e) {
            if (!searchInput.contains(e.target) && !resultsDiv.contains(e.target)) {
                resultsDiv.style.display = 'none';
            }
        });
    };

    function displayUniversalSearchResults(customers, resultsDiv) {
        const html = customers.map(customer => {
            const boatName = customer.boat_name || '';
            const boatLength = customer.boat_length || '';
            const email = customer.email || '';

            // Build boat display string
            let boatDisplay = '';
            if (boatName && boatLength) {
                boatDisplay = `${boatName} (${boatLength}ft)`;
            } else if (boatName) {
                boatDisplay = boatName;
            } else if (boatLength) {
                boatDisplay = `${boatLength}ft`;
            }

            // Build payment method display
            let paymentDisplay = '';
            if (customer.payment_methods && customer.payment_methods.length > 0) {
                const pm = customer.payment_methods[0];
                const brand = pm.card.brand.charAt(0).toUpperCase() + pm.card.brand.slice(1);
                const last4 = pm.card.last4;
                paymentDisplay = `<span class="payment-badge" style="background: #e8f5e9; border: 1px solid #4caf50; color: #2e7d32; padding: 2px 8px; border-radius: 4px; font-size: 12px; font-weight: 500; margin-left: 8px;">💳 ${brand} ••${last4}</span>`;
            }

            return `
                <div class="search-result-item" onclick="window.selectUniversalSearchCustomer(${JSON.stringify(customer).replace(/"/g, '&quot;')})">
                    <div class="customer-name">${customer.name}${boatDisplay ? ' → ' + boatDisplay : ''}</div>
                    <div class="customer-details">
                        <span class="email-badge">📧 ${email}</span>${paymentDisplay}
                    </div>
                </div>
            `;
        }).join('');

        resultsDiv.innerHTML = html;
        resultsDiv.style.display = 'block';
    }

    // Get customer's active service from customer_services table
    window.getCustomerActiveService = async function(stripeCustomerId) {
        try {
            const supabase = window.supabaseClient;
            if (!supabase) {
                console.error('Supabase client not initialized');
                return null;
            }

            const { data, error } = await supabase
                .from('customer_services')
                .select('*')
                .eq('customer_id', stripeCustomerId)
                .eq('status', 'active')
                .order('created_at', { ascending: false })
                .limit(1)
                .single();

            if (error && error.code === 'PGRST116') {
                // No active service - fallback to most recent service_logs
                console.log('No active service found, trying service_logs fallback...');
                return await window.getMostRecentService(stripeCustomerId);
            }

            if (error) {
                console.error('Error fetching active service:', error);
                return null;
            }

            return data;
        } catch (error) {
            console.error('Error in getCustomerActiveService:', error);
            return null;
        }
    };

    // Fallback: get most recent service from service_logs
    window.getMostRecentService = async function(customerId) {
        try {
            const supabase = window.supabaseClient;
            if (!supabase) {
                console.error('Supabase client not initialized');
                return null;
            }

            const { data, error } = await supabase
                .from('service_logs')
                .select('service_type')
                .eq('customer_id', customerId)
                .order('service_date', { ascending: false })
                .limit(1)
                .single();

            if (error && error.code === 'PGRST116') {
                // No service history found
                console.log('No service history found');
                return null;
            }

            if (error) {
                console.error('Error fetching recent service:', error);
                return null;
            }

            return data ? { service_type: data.service_type, service_name: data.service_type.replace(/_/g, ' ') } : null;
        } catch (error) {
            console.error('Error in getMostRecentService:', error);
            return null;
        }
    };

    window.selectUniversalSearchCustomer = async function(customer) {
        console.log('Selected customer with boat:', customer);

        // Hide search results
        document.getElementById('universalSearchResults').style.display = 'none';

        // Clear search input
        document.getElementById('universalSearch').value = '';

        // Store customer globally
        window.selectedCustomer = customer;
        if (window.adminApp) {
            window.adminApp.selectedCustomer = customer;
        }

        // Prepare boat object if boat data exists
        // Include both canonical names and aliases for backward compatibility
        let boat = null;
        if (customer.boat_id) {
            boat = {
                // Canonical fields (matching database schema)
                id: customer.boat_id,
                name: customer.boat_name,
                length: customer.boat_length,
                make: customer.boat_make,
                model: customer.boat_model,
                type: customer.boat_type,
                hull_type: customer.hull_type,
                propeller_count: customer.propeller_count,
                marina: customer.marina,
                dock: customer.dock,
                slip: customer.slip,

                // Alias fields for backward compatibility with various code paths
                boat_id: customer.boat_id,
                boat_name: customer.boat_name,
                boat_length: customer.boat_length,
                boat_length_ft: customer.boat_length,
                boat_type: customer.boat_type,
                marina_location: customer.marina,
                slip_number: customer.slip
            };
            window.selectedBoat = boat;
            console.log('✅ Pre-selected boat from search (with aliases):', window.selectedBoat);
        } else {
            window.selectedBoat = null;
        }

        // STEP 1: Get customer's active service
        const activeService = await window.getCustomerActiveService(customer.id);

        if (activeService && activeService.service_type) {
            // STEP 2: Auto-select the service
            console.log(`✅ Auto-selecting service: ${activeService.service_type}`);

            // Call the service selection function
            if (window.selectServiceDirect) {
                window.selectServiceDirect(activeService.service_type);
            }

            // STEP 3: Show service with "Change" button
            if (window.displaySelectedService) {
                window.displaySelectedService(activeService);
            }
        } else {
            // No active service - show service selection buttons
            console.log('ℹ️  No active service found - showing service options');
            if (window.showServiceSelectionButtons) {
                window.showServiceSelectionButtons();
            }
        }

        // Show customer info cards (new UX)
        if (typeof window.showCustomerInfoCards === 'function') {
            window.showCustomerInfoCards(customer, boat);
        }

        // Load saved anode assignments for this boat (AFTER showing cards)
        // Check for unsaved changes first and prompt user
        if (customer.boat_id && typeof window.loadBoatAnodes === 'function') {
            // Prompt if there are unsaved changes
            if (typeof window.promptUnsavedAnodeChanges === 'function') {
                const proceedWithLoad = await window.promptUnsavedAnodeChanges();
                if (!proceedWithLoad) {
                    console.log('⚠️ User cancelled boat selection due to unsaved changes');
                    return; // Don't proceed with loading new boat
                }
            }

            // Proceed with loading anodes
            await window.loadBoatAnodes(customer.boat_id);
        }

        // Load historical service conditions for paint, growth, propellers
        if (typeof window.loadHistoricalConditions === 'function') {
            await window.loadHistoricalConditions();
        }

        // Update propeller condition fields based on boat propeller count
        if (typeof window.updatePropellerConditionFields === 'function') {
            window.updatePropellerConditionFields();
        }

        // Show start service button when customer selected
        const startServiceContainer = document.getElementById('startServiceContainer');
        if (startServiceContainer) {
            startServiceContainer.style.display = 'block';
        }

        // Show conditions section
        const conditionsSection = document.getElementById('conditionsSection');
        if (conditionsSection) {
            conditionsSection.style.display = 'block';
        }

        // Scroll to customer info cards after autofill
        setTimeout(() => {
            const customerInfoCards = document.getElementById('customerInfoCards');
            if (customerInfoCards) {
                customerInfoCards.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 300);

        // Update charge summary
        if (window.updateChargeSummary && typeof window.updateChargeSummary === 'function') {
            window.updateChargeSummary();
        }
    };

    window.showServiceSelectionModal = function(customer, services) {
        const modal = document.getElementById('serviceSelectionModal');
        const customerInfo = document.getElementById('customerServiceInfo');
        const servicesList = document.getElementById('existingServicesList');

        // Show customer info
        customerInfo.innerHTML = `
            <div style="font-weight: 600; font-size: 16px; margin-bottom: 5px;">${customer.name}</div>
            ${customer.boat_name ? `<div style="font-size: 14px; color: #666;">🚤 ${customer.boat_name}</div>` : ''}
            <div style="font-size: 14px; color: #666;">${customer.email}</div>
        `;

        // Show services list
        const servicesHTML = services.map(service => {
            const serviceIcon = {
                'recurring_cleaning': '🔄',
                'onetime_cleaning': '✨',
                'underwater_inspection': '🔍',
                'item_recovery': '🔑',
                'propeller_service': '⚙️',
                'anodes_only': '🔋'
            }[service.service_type] || '📋';

            return `
                <button onclick='window.selectExistingService(${JSON.stringify(service).replace(/'/g, "\\'")})'
                        class="service-selection-btn"
                        style="width: 100%; padding: 15px; margin-bottom: 10px; background: white; border: 2px solid #ddd; border-radius: 8px; cursor: pointer; text-align: left; transition: all 0.2s;">
                    <div style="font-weight: 600; font-size: 15px; margin-bottom: 5px;">
                        ${serviceIcon} ${service.service_name}
                    </div>
                    <div style="font-size: 13px; color: #666;">
                        ${service.frequency ? `Frequency: ${service.frequency}` : ''}
                        ${service.boat_length ? ` • ${service.boat_length} ft` : ''}
                        ${service.base_price ? ` • $${service.base_price}` : ''}
                    </div>
                </button>
            `;
        }).join('');

        servicesList.innerHTML = `
            <div style="margin-bottom: 10px; font-weight: 500; color: #333;">Bill for recurring service:</div>
            ${servicesHTML}
        `;

        // Show modal
        modal.style.display = 'block';

        // Add hover effect via CSS
        const style = document.createElement('style');
        style.textContent = '.service-selection-btn:hover { border-color: #4CAF50; background: #f0f9ff; }';
        if (!document.getElementById('serviceSelectionStyles')) {
            style.id = 'serviceSelectionStyles';
            document.head.appendChild(style);
        }
    };

    window.closeServiceSelectionModal = function() {
        document.getElementById('serviceSelectionModal').style.display = 'none';
    };

    window.chooseManualService = function() {
        window.closeServiceSelectionModal();
        window.proceedWithManualService(window.selectedCustomer);
    };

    window.proceedWithManualService = function(customer) {
        // Show customer info card
        showSelectedCustomerCard(customer);

        // Scroll to service selector
        const serviceSelector = document.querySelector('.service-selector');
        if (serviceSelector) {
            serviceSelector.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    window.selectExistingService = function(service) {
        console.log('Selected existing service:', service);

        // Close modal
        window.closeServiceSelectionModal();

        // Store the selected service
        window.selectedRecurringService = service;

        // Pre-fill and auto-select the service
        window.currentServiceKey = service.service_type;
        if (window.adminApp) {
            window.adminApp.currentServiceKey = service.service_type;
        }

        // Call service selection with pre-fill flag
        window.selectServiceWithPrefill(service);
    };

    window.selectServiceWithPrefill = function(service) {
        const serviceKey = service.service_type;

        // Auto-select service button visually
        document.querySelectorAll('.simple-service-btn').forEach(btn => {
            btn.style.opacity = '0.6';
            btn.style.transform = 'scale(0.95)';
        });

        // Highlight selected service
        const selectedBtn = Array.from(document.querySelectorAll('.simple-service-btn'))
            .find(btn => btn.textContent.toLowerCase().includes(serviceKey.replace('_', ' ')));

        if (selectedBtn) {
            selectedBtn.style.opacity = '1';
            selectedBtn.style.transform = 'scale(1.05)';
        }

        // Determine if it's a cleaning service
        const isCleaningService = serviceKey === 'recurring_cleaning' || serviceKey === 'onetime_cleaning';

        // Render wizard with pre-fill flag
        if (window.renderConsolidatedForm) {
            window.renderConsolidatedForm(isCleaningService, serviceKey, true); // true = prefill mode
        }

        // Scroll to wizard
        setTimeout(() => {
            const wizardContainer = document.getElementById('wizardContainer');
            if (wizardContainer) {
                wizardContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 200);
    };

    // Show selected customer card
    function showSelectedCustomerCard(customer) {
        const card = document.getElementById('selectedCustomerCard');
        const nameEl = document.getElementById('selectedCustomerName');
        const detailsEl = document.getElementById('selectedCustomerDetails');

        if (!card || !nameEl || !detailsEl) return;

        // Build details string
        let details = [];
        if (customer.email) details.push(`📧 ${customer.email}`);
        if (customer.boat_name) details.push(`🚤 ${customer.boat_name}${customer.boat_length ? ' (' + customer.boat_length + 'ft)' : ''}`);
        if (customer.phone) details.push(`📞 ${customer.phone}`);

        nameEl.textContent = customer.name;
        detailsEl.textContent = details.join(' • ');

        card.style.display = 'block';

        // Update payment method display in charge summary
        updatePaymentMethodInChargeSummary(customer);
    }

    // Update payment method display in charge summary
    function updatePaymentMethodInChargeSummary(customer) {
        console.log('🔍 updatePaymentMethodInChargeSummary called with customer:', customer);

        const paymentMethodSelect = document.getElementById('paymentMethodSelect');
        if (!paymentMethodSelect) {
            console.warn('⚠️ paymentMethodSelect not found');
            return;
        }

        // Check if customer has payment methods
        if (customer && customer.payment_methods && customer.payment_methods.length > 0) {
            const pm = customer.payment_methods[0];
            console.log('💳 Found payment method:', pm);

            const brand = pm.card.brand.charAt(0).toUpperCase() + pm.card.brand.slice(1);
            const last4 = pm.card.last4;
            const expMonth = String(pm.card.exp_month).padStart(2, '0');
            const expYear = String(pm.card.exp_year).slice(-2);

            // Add saved card as first option
            const savedOption = document.createElement('option');
            savedOption.value = 'saved_card';
            savedOption.textContent = `💳 ${brand} •••• ${last4} (exp ${expMonth}/${expYear})`;
            savedOption.setAttribute('data-payment-method-id', pm.id);

            // Remove any existing saved card option
            const existingSaved = paymentMethodSelect.querySelector('option[value="saved_card"]');
            if (existingSaved) existingSaved.remove();

            // Insert as first option
            paymentMethodSelect.insertBefore(savedOption, paymentMethodSelect.firstChild);
            paymentMethodSelect.value = 'saved_card';

            // Store payment method ID globally
            window.customerPaymentMethodId = pm.id;

            // Add visual indicator next to Payment Method label
            const paymentMethodSelector = document.querySelector('.payment-method-selector');
            if (paymentMethodSelector) {
                let indicator = paymentMethodSelector.querySelector('.payment-method-indicator');
                if (!indicator) {
                    indicator = document.createElement('div');
                    indicator.className = 'payment-method-indicator';
                    indicator.style.cssText = 'display: inline-block; margin-left: 10px; padding: 4px 12px; background: #e8f5e9; border: 1px solid #4caf50; border-radius: 4px; color: #2e7d32; font-size: 13px; font-weight: 500;';
                    const label = paymentMethodSelector.querySelector('label');
                    if (label) {
                        label.appendChild(indicator);
                    }
                }
                indicator.textContent = `✓ Card on file: ${brand} ••${last4}`;
                indicator.style.display = 'inline-block';
            }

            console.log(`✅ Payment method added to dropdown: ${brand} •••• ${last4} (${pm.id})`);
        } else {
            console.log('⚠️ Customer has no saved payment methods. customer.payment_methods:', customer?.payment_methods);

            // Remove saved card option if it exists
            const existingSaved = paymentMethodSelect?.querySelector('option[value="saved_card"]');
            if (existingSaved) existingSaved.remove();

            // Hide visual indicator
            const indicator = document.querySelector('.payment-method-indicator');
            if (indicator) indicator.style.display = 'none';

            // Reset to default (stripe)
            if (paymentMethodSelect) paymentMethodSelect.value = 'stripe';
            window.customerPaymentMethodId = null;

            console.log('⚠️ No saved payment method');
        }
    }

    // Show new customer form
    window.showNewCustomerForm = function() {
        console.log('Showing new customer form');

        // Hide customer info cards if shown
        if (typeof window.hideCustomerInfoCards === 'function') {
            window.hideCustomerInfoCards();
        }

        // Get the form section
        const formSection = document.getElementById('newCustomerFormSection');
        if (!formSection) {
            console.error('newCustomerFormSection not found');
            return;
        }

        // Render the new customer form
        formSection.innerHTML = `
            <div style="background: #f8f9fa; border: 2px solid #ddd; border-radius: 12px; padding: 25px; margin-bottom: 20px;">
                <h3 style="margin-top: 0; margin-bottom: 20px; color: #333;">New Customer Information</h3>

                <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 15px;">
                    <div class="form-group">
                        <label>Name *</label>
                        <input type="text" id="newCustomerName" placeholder="John Doe" required />
                    </div>
                    <div class="form-group">
                        <label>Email *</label>
                        <input type="email" id="newCustomerEmail" placeholder="john@example.com" required />
                    </div>
                    <div class="form-group">
                        <label>Phone</label>
                        <input type="tel" id="newCustomerPhone" placeholder="(555) 123-4567" />
                    </div>
                </div>

                <h3 style="margin-top: 25px; margin-bottom: 15px; color: #333;">Boat Information</h3>

                <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 15px;">
                    <div class="form-group">
                        <label>Boat Name</label>
                        <input type="text" id="newBoatName" placeholder="Serenity" />
                    </div>
                    <div class="form-group">
                        <label>Length (ft) *</label>
                        <input type="number" id="newBoatLength" placeholder="35" required />
                    </div>
                    <div class="form-group">
                        <label>Dock</label>
                        <input type="text" id="newBoatDock" placeholder="A" />
                    </div>
                    <div class="form-group">
                        <label>Slip</label>
                        <input type="text" id="newBoatSlip" placeholder="12" />
                    </div>
                    <div class="form-group">
                        <label>Marina</label>
                        <input type="text" id="newBoatMarina" placeholder="San Francisco Marina" />
                    </div>
                    <div class="form-group">
                        <label>Type</label>
                        <select id="newBoatType">
                            <option value="sailboat">Sailboat</option>
                            <option value="powerboat">Powerboat</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>Hull Type</label>
                        <select id="newHullType">
                            <option value="monohull">Monohull</option>
                            <option value="catamaran">Catamaran</option>
                            <option value="trimaran">Trimaran</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label style="margin-top: 8px;">Number of Propellers</label>
                        <select id="newPropellerCount" style="width: 100%; padding: 8px; border: 1px solid #ddd; border-radius: 4px;">
                            <option value="0" selected>0 - No Propellers</option>
                            <option value="1">1 - Single Propeller</option>
                            <option value="2">2 - Twin Propellers</option>
                            <option value="3">3 - Triple Propellers</option>
                            <option value="4">4 - Quad Propellers</option>
                            <option value="5">5 - Five Propellers</option>
                        </select>
                    </div>
                </div>

                <div style="margin-top: 20px; display: flex; gap: 10px;">
                    <button onclick="window.saveNewCustomer()" style="padding: 12px 24px; background: #27ae60; color: white; border: none; border-radius: 6px; cursor: pointer; font-weight: 600;">
                        Continue with New Customer
                    </button>
                    <button onclick="window.cancelNewCustomer()" style="padding: 12px 24px; background: #95a5a6; color: white; border: none; border-radius: 6px; cursor: pointer; font-weight: 600;">
                        Cancel
                    </button>
                </div>
            </div>
        `;

        formSection.style.display = 'block';

        // Scroll to form
        setTimeout(() => {
            formSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
    };

    // Save new customer (temporary - will create in backend when service completes)
    window.saveNewCustomer = function() {
        // Collect form data
        const customerData = {
            name: document.getElementById('newCustomerName').value,
            email: document.getElementById('newCustomerEmail').value,
            phone: document.getElementById('newCustomerPhone').value
        };

        const boatData = {
            name: document.getElementById('newBoatName').value,
            length: document.getElementById('newBoatLength').value,
            dock: document.getElementById('newBoatDock').value,
            slip: document.getElementById('newBoatSlip').value,
            marina: document.getElementById('newBoatMarina').value,
            type: document.getElementById('newBoatType').value,
            hull_type: document.getElementById('newHullType').value,
            propeller_count: parseInt(document.getElementById('newPropellerCount').value)
        };

        // Validate required fields
        if (!customerData.name || !customerData.email || !boatData.length) {
            alert('Please fill in all required fields (Name, Email, Boat Length)');
            return;
        }

        // Store as pending new customer (will be created when service completes)
        window.selectedCustomer = {
            ...customerData,
            isNew: true
        };
        window.selectedBoat = {
            ...boatData,
            isNew: true
        };

        console.log('New customer data stored (pending creation):', window.selectedCustomer, window.selectedBoat);

        // Show customer info cards with the new data
        if (typeof window.showCustomerInfoCards === 'function') {
            window.showCustomerInfoCards(window.selectedCustomer, window.selectedBoat);
        }

        // Hide the form
        const formSection = document.getElementById('newCustomerFormSection');
        if (formSection) {
            formSection.style.display = 'none';
        }

        // Show conditions section
        const conditionsSection = document.getElementById('conditionsSection');
        if (conditionsSection) {
            conditionsSection.style.display = 'block';

            // Scroll to conditions section
            setTimeout(() => {
                conditionsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 300);
        }

        // Update charge summary
        if (window.updateChargeSummary && typeof window.updateChargeSummary === 'function') {
            window.updateChargeSummary();
        }
    };

    // Cancel new customer
    window.cancelNewCustomer = function() {
        const formSection = document.getElementById('newCustomerFormSection');
        if (formSection) {
            formSection.style.display = 'none';
            formSection.innerHTML = '';
        }
    };

    // Clear selected customer
    window.clearSelectedCustomer = function() {
        // Clear stored customer
        window.selectedCustomer = null;
        window.selectedBoat = null;
        if (window.adminApp) {
            window.adminApp.selectedCustomer = null;
        }

        // Hide cards
        if (typeof window.hideCustomerInfoCards === 'function') {
            window.hideCustomerInfoCards();
        }

        // Hide form
        const formSection = document.getElementById('newCustomerFormSection');
        if (formSection) {
            formSection.style.display = 'none';
        }

        // Hide conditions section
        const conditionsSection = document.getElementById('conditionsSection');
        if (conditionsSection) {
            conditionsSection.style.display = 'none';
        }

        // Clear search
        const searchInput = document.getElementById('universalSearch');
        if (searchInput) {
            searchInput.value = '';
        }
    };

    // Auto-fill wizard fields from selected customer (async to fetch from Supabase)
    window.autoFillWizardFromSelectedCustomer = async function() {
        const customer = window.selectedCustomer || window.adminApp?.selectedCustomer;
        if (!customer) {
            console.log('⚠️ No selected customer to auto-fill from');
            return;
        }

        console.log('🔄 Auto-filling wizard from customer:', customer.name);

        // Fill customer info fields from Stripe
        const nameField = document.getElementById('wizardCustomerName');
        if (nameField && customer.name) {
            nameField.value = customer.name;
            console.log('  ✓ Name:', customer.name);
        }

        const emailField = document.getElementById('wizardCustomerEmail');
        if (emailField && customer.email) {
            emailField.value = customer.email;
            console.log('  ✓ Email:', customer.email);
        }

        // Fetch boat data from Supabase (unless already pre-selected from search)
        try {
            const API_BASE_URL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
                ? 'http://localhost:3001/api'
                : '/api';

            console.log('  🔍 Fetching customer details from Supabase...');
            const response = await fetch(`${API_BASE_URL}/customer-details?stripeCustomerId=${customer.id}&email=${encodeURIComponent(customer.email)}`);
            const data = await response.json();

            // Fill phone number (Stripe first, then Supabase fallback)
            const phoneField = document.getElementById('wizardCustomerPhone');
            if (phoneField && customer.phone) {
                phoneField.value = customer.phone;
                console.log('  ✓ Phone (from Stripe):', customer.phone);
            } else if (phoneField && data.customer && data.customer.phone) {
                // Fall back to Supabase phone if Stripe doesn't have one
                phoneField.value = data.customer.phone;
                console.log('  ✓ Phone (from Supabase):', data.customer.phone);
            }

            // Use pre-selected boat from search if available, otherwise get from API
            let boat = window.selectedBoat;

            if (!boat && data.found && data.boats && data.boats.length > 0) {
                boat = data.boats[0]; // Use first boat if no pre-selection
                console.log('  🚤 Found boat from API:', boat.name);
                window.selectedBoat = boat;
            } else if (boat) {
                console.log('  🚤 Using pre-selected boat:', boat.name);
            }

            if (boat) {

                // Fill boat fields
                const boatNameField = document.getElementById('wizardBoatName');
                if (boatNameField && boat.name) {
                    boatNameField.value = boat.name;
                    console.log('  ✓ Boat name:', boat.name);
                    const boatNameHidden = document.getElementById('boatName');
                    if (boatNameHidden) boatNameHidden.value = boat.name;
                }

                // Boat length
                const boatLengthField = document.getElementById('wizardBoatLength') || document.getElementById('boat_length');
                if (boatLengthField) {
                    // Change placeholder to avoid confusion
                    boatLengthField.placeholder = 'Length (ft)';

                    if (boat.length) {
                        boatLengthField.value = boat.length;
                        console.log('  ✓ Boat length:', boat.length);
                        const boatLengthHidden = document.getElementById('boatLength');
                        if (boatLengthHidden) boatLengthHidden.value = boat.length;
                        // Trigger price recalculation
                        if (window.calculateCost) window.calculateCost();
                    } else {
                        console.log('  ⚠️ Boat length not found. boat.length =', boat.length);
                    }
                }

                const boatMakeField = document.getElementById('wizardBoatMake') || document.getElementById('boat_make');
                if (boatMakeField && boat.make) {
                    boatMakeField.value = boat.make;
                    console.log('  ✓ Boat make:', boat.make);
                }

                const boatModelField = document.getElementById('wizardBoatModel') || document.getElementById('boat_model');
                if (boatModelField && boat.model) {
                    boatModelField.value = boat.model;
                    console.log('  ✓ Boat model:', boat.model);
                }

                // Set boat type radio button
                const boatTypeInput = document.querySelector(`input[name="boat_type"][value="${boat.type}"]`);
                if (boatTypeInput) {
                    boatTypeInput.checked = true;
                    console.log('  ✓ Boat type:', boat.type);
                }

                // Set wizard boat type radio button
                const wizardBoatTypeInput = document.querySelector(`input[name="wizard_boat_type"][value="${boat.type}"]`);
                if (wizardBoatTypeInput) {
                    wizardBoatTypeInput.checked = true;
                    console.log('  ✓ Wizard boat type:', boat.type);
                }

                // Set hull type radio button
                const hullTypeInput = document.querySelector(`input[name="hull_type"][value="${boat.hull_type}"]`);
                if (hullTypeInput) {
                    hullTypeInput.checked = true;
                    console.log('  ✓ Hull type:', boat.hull_type);
                }

                // Set wizard hull type radio button
                const wizardHullTypeInput = document.querySelector(`input[name="wizard_hull_type"][value="${boat.hull_type}"]`);
                if (wizardHullTypeInput) {
                    wizardHullTypeInput.checked = true;
                    console.log('  ✓ Wizard hull type:', boat.hull_type);
                }

                // Set propeller count dropdown
                const propellerCountInput = document.getElementById('wizardPropellerCount');
                if (propellerCountInput && boat.propeller_count !== null && boat.propeller_count !== undefined) {
                    propellerCountInput.value = boat.propeller_count;
                    console.log('  ✓ Propeller count:', boat.propeller_count);
                }

                // Fill marina information
                if (boat.marina) {
                    const marinaField = document.getElementById('wizardMarina') || document.getElementById('marina') || document.getElementById('modalMarina');
                    if (marinaField) {
                        marinaField.value = boat.marina;
                        console.log('  ✓ Marina:', boat.marina);
                    }
                }

                // Fill dock information
                if (boat.dock) {
                    const dockField = document.getElementById('wizardDock') || document.getElementById('dock') || document.getElementById('modalDock');
                    if (dockField) {
                        dockField.value = boat.dock;
                        console.log('  ✓ Dock:', boat.dock);
                    }
                }

                // Fill slip information
                if (boat.slip) {
                    const slipField = document.getElementById('wizardSlip') || document.getElementById('slip') || document.getElementById('modalSlip');
                    if (slipField) {
                        slipField.value = boat.slip;
                        console.log('  ✓ Slip:', boat.slip);
                    }
                }

            } else {
                console.log('  ℹ️ No boat data found in Supabase for this customer');
            }

            // Fill address data if available
            if (data.addresses && data.addresses.length > 0) {
                const address = data.addresses[0]; // Use first address
                console.log('  🏠 Found address');

                // Store address data globally
                window.selectedAddress = address;

                // Fill street address
                if (address.street) {
                    const streetField = document.getElementById('wizardAddress') || document.getElementById('address') || document.getElementById('modalAddress');
                    if (streetField) {
                        streetField.value = address.street;
                        console.log('  ✓ Street address:', address.street);
                    }
                }

                // Fill city
                if (address.city) {
                    const cityField = document.getElementById('wizardCity') || document.getElementById('city') || document.getElementById('modalCity');
                    if (cityField) {
                        cityField.value = address.city;
                        console.log('  ✓ City:', address.city);
                    }
                }

                // Fill state
                if (address.state) {
                    const stateField = document.getElementById('wizardState') || document.getElementById('state') || document.getElementById('modalState');
                    if (stateField) {
                        stateField.value = address.state;
                        console.log('  ✓ State:', address.state);
                    }
                }

                // Fill ZIP code
                if (address.zip) {
                    const zipField = document.getElementById('wizardZip') || document.getElementById('zip') || document.getElementById('modalZip');
                    if (zipField) {
                        zipField.value = address.zip;
                        console.log('  ✓ ZIP:', address.zip);
                    }
                }
            } else {
                console.log('  ℹ️ No address data found in Supabase for this customer');
            }
        } catch (error) {
            console.error('  ❌ Error fetching boat data:', error);
        }

        console.log('✅ Auto-fill complete');
    };

    // Initialize when DOM is ready
    document.addEventListener('DOMContentLoaded', function() {
        // Wait a bit for other scripts to load
        setTimeout(window.initUniversalSearch, 500);
    });
  };

  // Auto-initialize
  window.initUniversalSearch();
  console.log('✅ Universal search initialized');
}
